export const DATA_HOOKS = {
  label: 'range-label',
  inputWrapper: 'range-input-wrapper',
  inputElement: 'wsr-input',
};
